import { useEffect, useState } from "react";
import { listSessions } from "@/api/sessions";

interface OutdoorLocations {
  areas: string[];
  cragsForArea: (area: string) => string[];
}

export function useOutdoorLocations(): OutdoorLocations {
  const [areas, setAreas] = useState<string[]>([]);
  const [areaCregs, setAreaCrags] = useState<Map<string, string[]>>(new Map());

  useEffect(() => {
    listSessions().then((sessions) => {
      const areaSet = new Set<string>();
      const cragMap = new Map<string, Set<string>>();

      for (const s of sessions) {
        if (s.session_type !== "outdoor") continue;
        if (s.area) {
          areaSet.add(s.area);
          if (s.crag_name) {
            if (!cragMap.has(s.area)) cragMap.set(s.area, new Set());
            cragMap.get(s.area)!.add(s.crag_name);
          }
        }
      }

      setAreas([...areaSet]);
      setAreaCrags(new Map([...cragMap.entries()].map(([a, c]) => [a, [...c]])));
    });
  }, []);

  return {
    areas,
    cragsForArea: (area: string) => areaCregs.get(area) ?? [],
  };
}
